export enum MyDocumentsTabs {
  RECEIPTS = 'RECEIPTS',
  LMN = 'LMN',
  STATEMENTS = 'STATEMENTS',
  TAX_FORMS = 'TAX_FORMS',
}

export const MyDocumentsTabsTitle = {
  [MyDocumentsTabs.RECEIPTS]: 'Receipts',
  [MyDocumentsTabs.LMN]: 'Letters of Medical Necessity',
  [MyDocumentsTabs.STATEMENTS]: 'Statements',
  [MyDocumentsTabs.TAX_FORMS]: 'Tax Forms',
} as const;

export interface Receipt {
  id?: string;
  claimId?: string;
  documentId?: string;
  fileUrl?: string;
  fileName?: string;
  providerName?: string;
  createdAt?: string;
}
